import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Styles from './FloatingHomeButton.module.scss';
import homeIcon from 'assets/images/home-chat-fab.png';
import { featureFlags } from 'config/featureFlags';

// Pages where the FAB should NOT appear
const HIDDEN_PATHS = [
  '/',
  '/login',
  '/registration',
  '/registration/step-two',
  '/registration/otp',
  '/registration/step-three',
  '/registration/step-four',
  '/forgot-password',
  '/restorePassword',
  '/callback',
  '/dashboard',
];

const SETTINGS_PATHS = new Set([
  '/profile/edit',
  '/invite-friend',
  '/currency',
  '/date-and-time',
  ...(featureFlags.showNotificationsSettings ? ['/notifications'] : []),
  '/email-notifications',
  '/terms-and-conditions',
  '/privacy-policy',
  '/subscription',
  '/feedback',
  ...(featureFlags.showExplainerVideo ? ['/explainer-video'] : []),
]);

const FloatingHomeButton: React.FC = () => {
  const location = useLocation();
  const history  = useHistory();

  const path = location.pathname;

  const isHidden =
    HIDDEN_PATHS.includes(path) ||
    path.startsWith('/registration') ||
    path.startsWith('/restore-password') ||
    path.startsWith('/reset-password');

  if (isHidden) return null;

  const isChatPage = path === '/chat-room' || path.startsWith('/chat-room/');
  const isSettingsPage = SETTINGS_PATHS.has(path);

  const handleClick = () => {
    history.push('/dashboard');
  };

  return (
    <button
      className={`${Styles.fab} ${isChatPage ? Styles.onChatPage : ''} ${isSettingsPage ? Styles.onSettingsPage : ''}`}
      onClick={handleClick}
      aria-label="Go to Dashboard"
      type="button"
    >
      <span className={Styles.fabBroadcast} aria-hidden="true">
        <span className={Styles.fabBroadcastPulse} />
        <span className={`${Styles.fabBroadcastPulse} ${Styles.fabBroadcastPulseDelay}`} />
      </span>
      <img src={homeIcon} alt="Home" className={Styles.fabIcon} />
    </button>
  );
};

export default FloatingHomeButton;
